module.exports = __webpack_public_path__ + "media/images/icons/mobile-45da8d33f45af328979322319b609636.svg";